/* Copyright (c) 2020-2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { useCallback } from "react";
import { Button, Flex, Spinner } from "@nordcloud/gnui";
import styles from "~/assets/styles/Runbook.module.css";
import { showSuccess } from "~/components";
import { useShowError } from "~/components/Error/useShowError";
import { Application } from "~/models";
import { generateActionSuccessText, useAxios } from "~/tools";

type Props = {
  application: Application;
  refetch: () => void;
};

function SaveRunbook({ application, refetch }: Props) {
  const [isLoading, setIsLoading] = React.useState(false);

  const { showError } = useShowError();
  const { Axios } = useAxios();

  const saveRunbook = useCallback(async () => {
    setIsLoading(true);
    try {
      await Axios().post(`/applications/${application.id}/runbook`);
      showSuccess(generateActionSuccessText("Runbook")()("created")());
      refetch();
    } catch (err) {
      showError(err.response);
    }
    setIsLoading(false);
  }, []);

  const loader = (
    <Flex>
      <Spinner color="white" />
      <div className={styles.savingLabel}>Saving...</div>
    </Flex>
  );

  return (
    <Flex justifyContent="center">
      <Button className={styles.saveButton} onClick={saveRunbook}>
        {isLoading ? loader : "Save"}
      </Button>
    </Flex>
  );
}

export { SaveRunbook };
